import Button from "@mui/material/Button";
import Testo from "../../elementi/Testo";
import { convertiDataHM, monFetch, apriAccordion } from "../../inc/inc";
import Cookies from "js-cookie";
import { useLocation, useParams } from "react-router-dom";
import Grid from "@mui/material/Grid";
import { useState, useEffect } from "react";
import Select from "@mui/material/Select";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";

import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";

import FormatListBulletedIcon from "@mui/icons-material/FormatListBulleted";

import Tooltip from "@mui/material/Tooltip";

import Popup from "../../elementi/Popup";

const apriSezioniDomanda = (idDomanda) => {
  //apri i box della domanda selezionata
  let dom = document.querySelector(".dom" + idDomanda);
  let sottosez = dom.closest(".boxSottosezione");
  let sez = dom.closest(".boxSezione");

  apriAccordion(sez, "boxSezione", "wrapSottosezione");

  apriAccordion(sottosez, "boxSottosezione", "boxDomande");

  setTimeout(() => {
    dom.scrollIntoView();
    window.scrollBy(0, -100);
  }, 500);

  dom.classList.add("lampeggia");
};

const Comp = (props) => {
  let params = useParams();
  let location = useLocation();

  let idDomandaSalvata = new URLSearchParams(location.search).get("dom");

  let id = params.id;

  const [cliente, setCliente] = useState(null);
  const [data, setData] = useState(new Date().toISOString().split("T")[0]);
  const [version, setVersion] = useState("");
  const [review, setReview] = useState(1);
  const [completo, setCompleto] = useState(false);
  const [fileName, setFileName] = useState("")

  const [filtro, setFiltro] = useState("tutte");

  const [popupConferma, setPopupConferma] = useState(false);
  const [daConfermare, setDaConfermare] = useState(null);

  const [optionsClienti, setOptionsClienti] = useState([]);

  const [domande, setDomande] = useState([]);

  async function queryQuestionario(id, filtro = null) {
    const res = await monFetch("/surveyGet", {
      id: id,
      filter: filtro,
    });
    const questionario = res.survey;
    setCliente(questionario.customer_id);
    setData(questionario.date);
    setVersion(questionario.version);
    setReview(questionario.review);
    setCompleto(questionario.completed);
    setFileName(questionario.fileName)
  }

  async function salvaQuestionario(e) {
    e.preventDefault();
    // return
    const res = await monFetch("/surveySet", {
      id: id,
      customer_id: cliente,
      date: data,
      version: version,
      review: review,
    });

    if (res.success) {
      if (res.id) {
        window.location.href = process.env.PUBLIC_URL + "/";
      } else {
        window.location.href = process.env.PUBLIC_URL + "/";
      }
    }
  }

  async function queryVersione() {
    // return
    const res = await monFetch("/surveyVersionDetail", {});
    setVersion(res.version);
  }

  async function queryReview(idCliente) {
    //cerco la review per quel cliente
    const res = await monFetch("/surveyGetReview", {
      customer_id: idCliente,
    });
    setReview(res.rev + 1);
  }

  async function queryClienti(e) {
    // return
    const res = await monFetch("/customerList", {});
    const temp = [];
    res.customer.forEach((el) => {
      temp.push({
        label: el.businessName,
        value: el.id,
      });
    });
    setOptionsClienti(temp);
  }

  async function queryDomandeQuestionario() {
    const res = await monFetch("/surveyGetQuestionList", {
      survey_id: id,
    });
    // console.log(res);
    setDomande(res.question);
  }

  async function settaCompletato(e, id) {
    e.stopPropagation();
    const res = await monFetch("/surveySetCompleted", { id });
    // console.log(res);
    // setPopupElimina(false);
    queryQuestionario(id);
  }

  useEffect(() => {
    props.setTestoTitolo(
      props.nuovo ? "Aggiungi Questionario" : "Modifica Questionario"
    );

    queryClienti();

    if (id) {
      queryQuestionario(id);
    } else {
      //se nuovo
      queryVersione();
    }

    //query delle domande del questionario
    queryDomandeQuestionario();
  }, []);

  function apriTutti(direzione) {
    document.querySelectorAll(".boxSezione").forEach((el) => {
      apriAccordion(el, "boxSezione", "wrapSottosezione", direzione);
      el.querySelectorAll(".rigaSottosezione").forEach((el2) => {
        apriAccordion(el2, "boxSottosezione", "boxDomande", direzione);
      });
    });
  }

  useEffect(() => {
    if (domande.length > 0 && idDomandaSalvata) {
      apriSezioniDomanda(idDomandaSalvata);
    }
  }, [domande]);

  return (
    <>
      <form onSubmit={(e) => salvaQuestionario(e)}>
        <Grid container spacing={2}>
          <Grid item sm={4} xs={12}>
            <FormControl fullWidth size="small" required>
              <InputLabel>Cliente</InputLabel>
              <Select
                fullWidth
                label="Cliente"
                value={cliente || ""}
                onChange={(e) => {
                  setCliente(e.target.value);
                  queryReview(e.target.value);
                }}
              >
                {optionsClienti.map((el) => (
                  <MenuItem key={el.value} value={el.value}>
                    {el.label}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>

          <Grid item sm={2} xs={12}>
            <Testo
              disabled
              required
              type="date"
              label="Data"
              value={data || ""}
              InputLabelProps={{ shrink: true }}
              onChange={(e) => {
                setData(e.target.value);
              }}
            />
          </Grid>
          <Grid item sm={2} xs={12}>
            <Testo
              disabled
              label="Versione"
              value={convertiDataHM(version * 1000) || ""}
            />
          </Grid>
          <Grid item sm={2} xs={12}>
            <Testo
              disabled
              label="Codice Versione"
              value={version}
            />
          </Grid>
          <Grid item sm={2} xs={12}>
            <Testo
              disabled
              required
              type="number"
              label="Review"
              value={review || ""}
              onChange={(e) => {
                setReview(e.target.value);
              }}
            />
          </Grid>

          <Grid item sm={12} xs={12}>
            <div className="flexSpaceBetween">
              <Button
                className="buttonIndietro"
                href={process.env.PUBLIC_URL + "/"}
                variant="contained"
                style={{ marginRight: 8 }}
              >
                Indietro
              </Button>
              <div>
                {!completo && id && (
                  //da iniziare
                  <Button
                    className="buttonSuccess"
                    variant="contained"
                    style={{ marginRight: 8 }}
                    onClick={(e) => {
                      e.stopPropagation();
                      setDaConfermare(id);
                      setPopupConferma(true);
                    }}
                  >
                    Setta Come Completo
                  </Button>
                )}
                {completo == 1 && (
                  //completo
                  <b style={{ marginRight: 8 }}>Completato</b>
                )}
                {id && (
                  <Button
                    className="buttonSalva"
                    style={{ marginRight: 8 }}
                    variant="contained"
                    href={process.env.REACT_APP_BACKEND + "/pdf/cli/" + id+ "/" + fileName + "_cliente"}
                    target="_blank"
                    onClick={(e) => {
                      e.stopPropagation();
                    }}
                  >
                    PDF Cliente
                  </Button>
                )}
                {id && (
                  <Button
                    className="buttonSalva"
                    style={{ marginRight: 8 }}
                    variant="contained"
                    href={process.env.REACT_APP_BACKEND + "/pdf/aud/" + id+ "/" + fileName + "_auditor"}
                    target="_blank"
                    onClick={(e) => {
                      e.stopPropagation();
                    }}
                  >
                    Relazione completa
                  </Button>
                )}
                {id && (
                  <Button
                    className="buttonSalva"
                    variant="contained"
                    style={{ marginRight: 8 }}
                    href={process.env.REACT_APP_BACKEND + "/pdf/com/" + id+ "/" + fileName + "_commerciale"}
                    target="_blank"
                    onClick={(e) => {
                      e.stopPropagation();
                    }}
                  >
                    Relazione Commerciale
                  </Button>
                )}
                <Button
                  className="buttonSuccess"
                  type="submit"
                  variant="contained"
                >
                  {id ? "Salva" : "Avanti"}
                </Button>
              </div>
            </div>
          </Grid>
        </Grid>
      </form>

      <br />

      {id && (
        <Grid container spacing={2}>
          <Grid item sm={4} xs={12}>
            <FormControl fullWidth size="small">
              <InputLabel>Filtra risposte</InputLabel>
              <Select
                fullWidth
                label="Filtra risposte"
                value={filtro}
                onChange={(e) => {
                  setFiltro(e.target.value);
                  queryQuestionario(id, e.target.value);
                }}
              >
                <MenuItem value={"tutte"}>Tutte</MenuItem>
                <MenuItem value={"saltate"}>Saltate</MenuItem>
                <MenuItem value={"mancanti"}>Mancanti</MenuItem>
              </Select>
            </FormControl>
          </Grid>
          <Grid item sm={8} xs={12}>
            <Button
              className="buttonSalva"
              variant="contained"
              style={{ marginRight: 8 }}
              onClick={(e) => {
                apriTutti("apri");
              }}
            >
              Mostra Tutte
            </Button>
            <Button
              className="buttonSalva"
              variant="contained"
              style={{ marginRight: 8 }}
              onClick={(e) => {
                apriTutti("chiudi");
              }}
            >
              Nascondi Tutte
            </Button>
          </Grid>
        </Grid>
      )}
      <br />
      {domande.map((el, index) => {
        //setta sezione aperta
        // let classeAperto = "";
        // if (el.boxOpen) {
        //   classeAperto = "aperto";
        // }
        let classeUnivoca = "bsez" + index;
        return (
          <div
            className={"pointer boxSezione boxAccordion " + classeUnivoca}
            key={index}
            onClick={(e) => {
              // console.log(e)
              //setta apertura sezione
              // let temp = [...domande];
              // if (!temp[index].boxOpen) {
              apriAccordion(
                e.target,
                "boxSezione",
                // classeUnivoca,
                "wrapSottosezione"
              );
              // temp[index].boxOpen = true;
              // } else {
              //   apriAccordion(
              //     false,
              //     "boxSezione",
              //     classeUnivoca,
              //     "wrapSottosezione"
              //   );
              //   // temp[index].boxOpen = false;
              // }
              // setDomande(temp);
            }}
          >
            <div className="rigaSezione bgColor">
              <FormatListBulletedIcon /> <span>{el.section}</span>
            </div>
            <div className="wrapSottosezione">
              {el.subsection.map((el, index2) => {
                //setta sottosezione aperta
                // let classeAperto = "";
                // if (el.boxOpen) {
                //   classeAperto = "aperto";
                // }
                let classeUnivoca = "bsez" + index + "ss" + index2;
                return (
                  <div
                    className={
                      "pointer boxSottosezione boxAccordion " + classeUnivoca
                    }
                    key={index2}
                    onClick={(e) => {
                      e.stopPropagation();
                      //setta apertura sottosezione
                      // let temp = [...domande];
                      // if (!temp[index]["subsection"][index2].boxOpen) {
                      apriAccordion(
                        e.target,
                        "boxSottosezione",
                        // classeUnivoca,
                        "boxDomande"
                      );
                      //   // temp[index]["subsection"][index2].boxOpen = true;
                      // } else {
                      //   apriAccordion(
                      //     e.target,
                      //     "boxSottosezione",
                      //     classeUnivoca,
                      //     "boxDomande"
                      //   );
                      // temp[index]["subsection"][index2].boxOpen = false;
                      // }
                      // console.log(temp);
                      // setDomande(temp);
                    }}
                  >
                    <div className="rigaSottosezione bgColorLight">
                      {el.name}
                    </div>
                    <div className="boxDomande">
                      <Table className="">
                        <TableHead>
                          <TableRow>
                            <TableCell>#</TableCell>
                            {/* <TableCell></TableCell>
                            <TableCell>Sottosezione</TableCell> */}
                            <TableCell>Testo domanda</TableCell>
                            <TableCell>Annot. Cliente</TableCell>
                            <TableCell>Note Intervistatore</TableCell>
                            <TableCell>Risposta</TableCell>
                            <TableCell></TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {el.questions.map((dom, index) => {
                            // //mostra le frecce per ordinamento
                            // let mostraFrecciaSu = true;
                            // let mostraFrecciaGiu = true;
                            // if (index == 0 || cambioSezione == true) {
                            //   mostraFrecciaSu = false;
                            // }
                            // if (index == (domande.length - 1)) {
                            //   mostraFrecciaGiu = false;
                            // }
                            // //

                            let classeRisposto = "";
                            if (dom.ca_skipped) {
                              classeRisposto = "saltato";
                              //nascondi con filtro
                              if (filtro != "tutte" && filtro != "saltate") {
                                classeRisposto += " nascosto ";
                              }
                            } else if (dom.ca_answer) {
                              classeRisposto = "risposto";
                              //nascondi con filtro
                              if (filtro != "tutte") {
                                classeRisposto += " nascosto ";
                              }
                            } else {
                              classeRisposto = "mancante";
                              //nascondi con filtro
                              if (filtro != "tutte" && filtro != "mancanti") {
                                classeRisposto += " nascosto ";
                              }
                            }

                            return (
                              <TableRow
                                key={dom.id}
                                className={
                                  "rigaSelezionabile dom" +
                                  dom.id +
                                  " " +
                                  classeRisposto
                                }
                                onClick={(e) => {
                                  e.stopPropagation();
                                  // window.location.href = process.env.PUBLIC_URL+"/domanda/" + dom.id;
                                }}
                              >
                                <TableCell>{dom.order}</TableCell>
                                <TableCell
                                // className="limitaTesto"
                                >
                                  <Tooltip
                                    title={
                                      <div
                                        dangerouslySetInnerHTML={{
                                          __html: dom.textNoHtml,
                                        }}
                                        style={{ margin: 0 }}
                                      ></div>
                                    }
                                  >
                                    <div
                                      dangerouslySetInnerHTML={{
                                        __html: dom.textNoHtml,
                                      }}
                                    ></div>
                                  </Tooltip>
                                </TableCell>
                                <TableCell className="limitaTesto">
                                  <div
                                    dangerouslySetInnerHTML={{
                                      __html: dom.ca_customer_note,
                                    }}
                                  ></div>
                                </TableCell>
                                <TableCell className="limitaTesto">
                                  <div
                                    dangerouslySetInnerHTML={{
                                      __html: dom.ca_internal_note,
                                    }}
                                  ></div>
                                </TableCell>
                                <TableCell className="limitaTesto">
                                  {dom.ca_answerText}
                                  {dom.ca_answerText2 ? " | " + dom.ca_answerText2 : ""}
                                  {dom.ca_answerText3 ? " | " + dom.ca_answerText3 : ""}
                                  {dom.ca_answerText4 ? " | " + dom.ca_answerText4 : ""}
                                  {dom.ca_answerText5 ? " | " + dom.ca_answerText5 : ""}
                                </TableCell>

                                <TableCell>
                                  <Button
                                    variant="contained"
                                    className="buttonSalva"
                                    href={process.env.PUBLIC_URL + "/questionario/domanda/" + dom.id}
                                    onClick={() => {
                                      Cookies.set("idQuestionario", id);
                                    }}
                                  >
                                    Apri
                                  </Button>
                                </TableCell>
                              </TableRow>
                            );
                          })}
                        </TableBody>
                      </Table>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        );
      })}
      <Popup
        open={popupConferma}
        titolo={"Conferma completamento"}
        testo={"Confermi che il questionario è completo?"}
        fnAnnulla={(e) => setPopupConferma(false)}
        fnSuccess={(e) => {
          settaCompletato(e, daConfermare);
          setPopupConferma(false);
        }}
      />
    </>
  );
};

export default Comp;
